/**
 * When a scheduled bot start may fire, VN time: mirrors the BE's `daily/start-window.ts`
 * (keep the two in sync). Outside these the broker is not trading, so the BE refuses to save
 * such a schedule and skips a start that fires late.
 */
export const START_WINDOWS: ReadonlyArray<readonly [number, number]> = [
  [8 * 60 + 30, 11 * 60 + 25],
  [13 * 60, 14 * 60 + 25],
];
export const START_WINDOWS_TEXT = '08:30–11:25 or 13:00–14:25';

export const inStartWindow = (minuteOfDay: number): boolean =>
  START_WINDOWS.some(([a, b]) => minuteOfDay >= a && minuteOfDay <= b);

/** antd TimePicker `disabledTime`: every hour/minute that falls outside the windows. */
export const startWindowDisabledTime = () => ({
  disabledHours: () => Array.from({ length: 24 }, (_, h) => h).filter((h) => !Array.from({ length: 60 }, (_, m) => m).some((m) => inStartWindow(h * 60 + m))),
  disabledMinutes: (hour: number) => Array.from({ length: 60 }, (_, m) => m).filter((m) => !inStartWindow(hour * 60 + m)),
});
